<template>
  <div class="main-body">
    <div class="header">评价管理</div>
    <div class="out">

      <div class="search2">

        <div style="float: right">


          <el-select v-model="isBed" placeholder="请选择评价类型" clearable style="margin-right: 5px;">
            <el-option
                v-for="item in bed_arr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>

          <el-button size="mini" type="primary" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th" border style="width: 100%;">
        <el-table-column prop="elderlyDTO.name" label="评价人" width="100"></el-table-column>
        <el-table-column prop="elderlyDTO.userPhone" label="手机号" width="120"></el-table-column>

        <el-table-column prop="remarks" label="评价内容" width="150"></el-table-column>
        <el-table-column prop="createTime" :formatter="timefilter" width="200" label="评价时间"></el-table-column>

        <el-table-column width="105" label="订单来源" >
          <template slot-scope="scope">
            <div v-if="scope.row.isBed =='1'">差评</div>
            <div v-if="scope.row.isBed !='1' ">好评</div>

          </template>
        </el-table-column>


        <el-table-column
            prop="orderBusiness.isSchedule"
            :formatter="isSchedules"
            label="预订单">
        </el-table-column>


        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleInfo(scope.$index, scope.row)">详情</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <AppraiseInfo ref="myAppraiseInfo" v-show="showModalAppraiseInfo" v-bind:goodsClassValue="goodsClassValue" v-on:closeAppraiseInfo="closeAppraiseInfo" v-on:getList="getList"></AppraiseInfo>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import AppraiseInfo from "../PageServe/AppraiseInfo";
import {getGovernmentCode, getStaffCode, getStaffDTO} from "@/utils/auth";

export default {
  name: "Role",
  data(){
    return{
      tableLoading:false,
      showModalAppraiseInfo:false,
      tableData:null,
      goodsClassCode:'',
      name:null,
      businessCode:'',
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      th:0,
      goodsClassValue:[],

      isBed:-1,
      bed_arr: [
        {value: -1, label: '全部'},
        {value: 0, label: '好评'},
        {value: 1, label: '差评'},
      ],

    }
  },
  components:{
    AppraiseInfo
  },
  created(){
    this.getBusiness();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      console.log(val);
      this.th = val;
    },
  },
  methods:{
    //日期格式
    timefilter(row, column, cellValue){
      return timefilters(cellValue)
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    handleInfo:function(index,row){
      this.showModalAppraiseInfo = !this.showModalAppraiseInfo;
      this.$refs.myAppraiseInfo.init(row);
    },
    closeAppraiseInfo:function(){
      this.showModalAppraiseInfo = !this.showModalAppraiseInfo;
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1
      var _this=this
      this.tableLoading=true


      let isBed = this.isBed;

      if(this.isBed === null){
        console.log("null");
        isBed = -1;
      }
      if(this.isBed===''){
        console.log("empty");
        isBed = -1;
      }


      this.$axios({
        method: 'post',
        url: this.$shopUrl+"OrderBusinessAppraise/PageGov",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          isBed:isBed,
          businessCode:this.businessCode,
        }
      }).then( (response)=> {
        _this.tableLoading=false
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        _this.tableLoading=false
        console.log(error);
      });
    },

    statusTitle(row, column, cellValue){
      return this.allStatus(cellValue,["",'普通商品订单','社会化服务订单','政府购买服务订单']);
    },
    isSchedules(row, column, cellValue){
      return this.allStatus(cellValue,['否','是']);
    },
    statuss(row, column, cellValue){
      return this.allStatus(cellValue,['待付款','待发货','待收货','交易成功','退款中','交易关闭','交易取消','已评价',"","",'待付款','待接单','已接单','服务中','服务完成','交易取消','已评价']);
    },
    allStatus(row,status){
      for(var i in status){
        if(i==row){
          return status[i]
        }
      }
      return "其它";
    },


    getBusiness(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/GovList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          governmentCode: getGovernmentCode(),
          businessType:6,
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.arr_business = response.data.data;
              if(this.arr_business.length>0){
                this.businessCode = this.arr_business[0].businessCode;
                this.getList();
              }

            }else if(response.data.error === 1){
              this.$message.error(response.data.message)
            }

          }
      )

    },


  }
}
</script>

<style scoped>

</style>
